import SvgIcon from "@material-ui/core/SvgIcon";
import React from "react";

function Linkgo(props) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 2000 2000"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Beyaz arkaplan dairesi */}
      <circle cx="1000" cy="1000" r="1000" fill="#ffffff" stroke="#e0e0e0" strokeWidth="2" />
      <g id="katman_1">
        <path
          d="M1053.2,908.89c4.69,37.26,9.73,76.13,14.25,114.33-59.68,7.63-129.24,49.16-151.42,107.22-18.32,47.95,12.57,211.73,19.57,271.51,4.48,38.3,9.19,76.16,14.25,114.33,5.74,43.21,5.39,88.79,17.29,130.94,48.77,172.7,370.27,139.03,353.25-79.07-11.17-143.27-45.24-293.77-58.61-437.88-8.17-40.76-43.4-65.85-76.75-85.62-5.01-42.46-8.99-87.47-14.25-128.63,64.54,14.75,132.82,57.87,170.39,113.21,31.24,46.04,38.8,102.81,46.48,157.05,18.1,127.79,26.84,257.56,43.12,385.67l1.42,9.58c.04,14.57,4.66,30.57,2.3,45.51-31.46,199.24-274.62,301.29-444.26,211.41-139.86-74.11-140.55-189.61-157.97-329.32-5.17-41.46-9.49-83.54-14.25-125.05-9.04-78.79-33.09-189.1-15.41-263.77,26.9-113.65,137.49-197.13,250.6-211.43Z"
          fill="#f18727"
        />
      </g>
      <g id="katman_2">
        <path
          d="M1170.8,916.04c5.26,41.15,9.24,86.17,14.25,128.63,8.44,71.45,32.22,178.98,19.8,246.73-22.67,123.63-133.98,210.34-254.99,224.9-5.07-38.17-9.77-76.04-14.25-114.33,76.94-3.07,161.12-75.06,160.66-155.42-.36-64.26-20.88-156.38-28.81-223.32-4.53-38.2-9.57-77.07-14.25-114.33-4.49-35.69-4.76-73.02-11.19-108.48-36.19-199.77-368.91-162.03-359.38,42.35,6.62,142.09,44.89,295.15,54.48,438.45,7.94,45.06,39.19,84.73,80.9,102.89,4.76,41.51,9.08,83.6,14.25,125.05-114.97-25.26-190.6-107.91-209.74-223.82-26.16-158.41-37.04-322.07-53.5-481.38,27.02-231.39,328.23-326.62,498.48-179.15,91.88,79.59,88.93,178.93,103.3,291.24Z"
          fill="#153755"
        />
      </g>
      <g id="katman_3">
        <circle cx="777.91" cy="307.76" r="178.08" fill="#143654" />
      </g>
    </SvgIcon>
  );
}

export default Linkgo;
